const ANALYTICS = 'Аналитическая справка'
const STATISTICS = 'Статистическая справка'
const EXPERT_OPINION = 'Экспертное заключение'
const PRIMARY_RESULTS = 'Представление первичных результатов'
const SUMMARY_OF_PRIMARY_RESULTS = 'СВОД. Представление первичных результатов'

interface ReportItem {
  text: string;
  value: string;
  isFilterable: boolean;
  isReturnOneFile: boolean;
}


export const getReportsList = (isRegMeh: boolean): ReportItem[] => {
  const suffix = isRegMeh ? 'РУМ' : 'МУМ'
  const prefix = isRegMeh ? 'reg_' : 'mun_'
  const all = '(все)'

  const result: ReportItem[] = [
    {
      text: [STATISTICS, suffix, all].join(' '),
      value: isRegMeh ? 'mun_meh.region_statistics' : 'mun_meh.municipality_statistics',
      isFilterable: !isRegMeh,
      isReturnOneFile: false,
    },
    {
      text: [EXPERT_OPINION, suffix, all].join(' '),
      value: `mun_meh.${prefix}expert_opinion`,
      isFilterable: !isRegMeh,
      isReturnOneFile: false,
    },
    {
      text: [PRIMARY_RESULTS, suffix, all].join(' '),
      value: `mun_meh.${prefix}primary_results`,
      isFilterable: !isRegMeh,
      isReturnOneFile: false,
    },
    {
      text: [ANALYTICS, suffix, all].join(' '),
      value: `mun_meh.${prefix}analytical_ref`,
      isFilterable: !isRegMeh,
      isReturnOneFile: false,
    },
    {
      text: [SUMMARY_OF_PRIMARY_RESULTS, suffix].join(' '),
      value: `mun_meh.${prefix}cons_primary_results`,
      isFilterable: !isRegMeh,
      isReturnOneFile: true,
    },
  ]

  if (isRegMeh) {
    result.push(
      {
        text: 'Рейтинг РУМ. Итоговый балл',
        value: 'mun_meh.reg_rating_total_mark',
        isFilterable: false,
        isReturnOneFile: true,
      },
      {
        text: 'Рейтинг РУМ. Направления',
        value: 'mun_meh.reg_rating_direction_mark',
        isFilterable: false,
        isReturnOneFile: true,
      },
      {
        text: 'Рейтинг РУМ. Свод',
        value: 'mun_meh.reg_cons_rating',
        isFilterable: false,
        isReturnOneFile: true,
      },
    )
  }
  return result
}
